import React from 'react';
import { Typography, Box, List, ListItem, ListItemText } from '@mui/material';
import LegalLayout from './LegalLayout';

const TermsOfService: React.FC = () => {
  return (
    <LegalLayout title="Общи условия">
      <Typography variant="h5" component="h2" gutterBottom>
        1. Общи положения
      </Typography>
      <Typography paragraph>
        Настоящите общи условия регулират ползването на уебсайта goldenbooks.bg, 
        собственост на "Голдън Букс" ЕООД (Golden Books Ltd), със седалище София, България.
      </Typography>
      <Typography paragraph>
        Използвайки нашия уебсайт, Вие се съгласявате с настоящите общи условия. 
        Ако не се съгласявате с тях, моля не използвайте сайта.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        2. Дефиниции
      </Typography>
      <Box component="ul" sx={{ pl: 2 }}>
        <Typography component="li" paragraph>
          <strong>"Потребител"</strong> - всяко физическо или юридическо лице, което използва услугите на сайта
        </Typography>
        <Typography component="li" paragraph>
          <strong>"Продавач"</strong> - "Голдън Букс" ЕООД
        </Typography>
        <Typography component="li" paragraph>
          <strong>"Сайт"</strong> - goldenbooks.bg и всички свързани поддомейни
        </Typography>
      </Box>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        3. Използване на уебсайта
      </Typography>
      <Typography paragraph>
        Уебсайтът е достъпен 24 часа в денонощието, 7 дни в седмицата. 
        Поръчки могат да бъдат направени както от регистрирани потребители, така и от гости.
      </Typography>
      <Typography paragraph>
        За да направите поръчка, е необходимо да предоставите следната информация:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Име и фамилия" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Имейл адрес" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Телефонен номер" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Адрес за доставка" />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        4. Поръчки и плащане
      </Typography>
      <Typography paragraph>
        Приемаме следните методи за плащане:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Наложен платеж (при доставка)" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Банков превод - за момента не приложимо" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Онлайн плащане с карта - за момента не приложимо" />
        </ListItem>
      </List>
      <Typography paragraph>
        Всички цени са в евро и включват ДДС.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        5. Доставка
      </Typography>
      <Typography paragraph>
        Предлагаме безплатна доставка за поръчки над 150 €.
        За поръчки под тази сума се начислява такса за доставка според тарифите на куриерската фирма.
      </Typography>
      <Typography paragraph>
        Доставката се извършва в рамките на 3 работни дни чрез куриерска фирма. 
        Международни доставки се уговарят индивидуално.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        6. Връщане и рекламации
      </Typography>
      <Typography paragraph>
        Имате право да върнете продукта в 14-дневен срок от получаването му, 
        съгласно Закона за защита на потребителите. За книги този срок е 3 дни.
      </Typography>
      <Typography paragraph>
        Възстановяване на средствата се извършва в 30-дневен срок след получаване
        на върнатия продукт в оригинално състояние.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        7. Интелектуална собственост
      </Typography>
      <Typography paragraph>
        Всички материали на сайта (текстове, изображения, логота, дизайн) са 
        защитени от авторско право и принадлежат на "Голдън Букс" ЕООД или 
        съответните правообладатели.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        8. Отговорност
      </Typography>
      <Typography paragraph>
        "Голдън Букс" ЕООД не носи отговорност за непреки щети или загуби, 
        възникнали от използването на сайта или закупените продукти, 
        освен в случаите, предвидени в задължителното законодателство.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        9. Приложимо право
      </Typography>
      <Typography paragraph>
        Настоящите общи условия се регулират от българското законодателство. 
        Всички спорове се решават от компетентните български съдилища.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        10. Контакти
      </Typography>
      <Typography paragraph>
        "Голдън Букс" ЕООД<br />
        София, България<br />
        Имейл: info@goldenbooks.bg<br />
        Телефон: 0895628293<br />
        Работно време: 9:00 - 18:00 ч.
      </Typography>
    </LegalLayout>
  );
};

export default TermsOfService;